import { useViewTransition } from '@src/hooks/useViewTransition';
import { FileRouteTypes, Link } from '@tanstack/react-router';
import React from 'react';
import { BiChevronRight } from 'react-icons/bi';
import { HStack } from 'ui_2';

type Props = {
  children: React.ReactNode;
  toRoute: FileRouteTypes['to'];
};

export const HomePageNav = ({ children, toRoute }: Props) => {
  const { slideLeftFullPage } = useViewTransition();

  return (
    <Link to={toRoute} viewTransition={slideLeftFullPage} className='w-1/2'>
      <HStack className='w-full items-center gap-1 rounded-[5px] border border-gray-100 p-2'>
        {children}
        <BiChevronRight className='text-gray-400' />
      </HStack>
    </Link>
  );
};
